import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://pdadrlkcrydmtuhuruoh.supabase.co';
const SUPABASE_KEY = 'sb_publishable__Ab6X5WU65eLPN77bIWyZw_7SReMXLn';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);